/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : REQUEST DEMO : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	signin: {
		'& .form': {
			'& .grid': {
				'& .name-helpers': {
					justifyContent: 'space-between',
					alignItems: 'center',
					alignContent: 'center',
					'& .griditem': {
						minWidth: `${pxToEm(200)} !important`,
						width: 'auto',
						'& .field': {
							minWidth: `${pxToEm(200)} !important` // used to drop info or errormessage down beneath the form element and label
						}
					}
				}
			}
		}
	}
});